module.exports = __webpack_public_path__ + "static/media/Image-Intro.b49f9340.webp";